// packages
import 'intersection-observer';
import yall from 'yall-js';

// local imports
import { AdLoader } from './ads/loader';
import { boot as bootCounter } from './countdown';
import { boot as bootNav } from './nav';

// Kickstart the ads
const adLoader = new AdLoader({ adSection: window.AD_SECTION });
adLoader.init();

bootCounter();

// Kickstart the lazy image loading
document.addEventListener('DOMContentLoaded', yall);

bootNav();
